import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    SAVE_CONSIGNMENTRETURN_ORDER_FAILURE,
    SAVE_CONSIGNMENTRETURN_ORDER_SUCCESS,
} from '../actions';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* postConsignmentOrderReturn(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/consignment/return`;
    const payload = removeEmptyFieldsFromObject(action.payload);

     try {
    const result = yield axios
        .post(url, payload)
        .then((response) => response.data);
    // const modify_result = {
    //     ...result,
    // };
    // if (result && result.statusCode === '200') {
    //     console.log('IN IF BLOCK');
        yield put({
            type: SAVE_CONSIGNMENTRETURN_ORDER_SUCCESS,
            data: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: payload
        });
        yield put({
            type: SAVE_CONSIGNMENTRETURN_ORDER_FAILURE,
            data: {
                message: 'error',
                statusCode: '422',
            },
        });
    }
    // }
}
